import { render, staticRenderFns } from "./vue-draggable-div.vue?vue&type=template&id=39e62d5b&"
import script from "./vue-draggable-div.vue?vue&type=script&lang=js&"
export * from "./vue-draggable-div.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports